<template>
    <list-group-item :action="clickAction" color="primary">
        <i class="fas fa-file-invoice"></i> <strong>Resolution Center Request Pending for Booking #{{ resCenter.bookingId }}</strong>
    </list-group-item>
</template>

<script type="text/javascript">
    import UIComponents from '@/components/UI/index.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...UIComponents,
        },

        emits: ['click'],

        props: {
            resCenter: {
                type: ApiObject,
                required: true,
            }
        },

        methods: {
            clickAction() {
                this.$emit('click');
                this.$router.push('/owners/resolution-center/'+this.bookingId);
            },
        },
    }
</script>